import React from 'react';

export default function TabLayout({
  children,
  header,
}: {
  children: React.ReactElement | React.ReactElement[];
  header?: React.ReactElement;
}) {
  return (
    <div className="p-6 sm:p-8" data-testid="post-details-tab-layout">
      {header}

      <hr
        className="mt-6 mb-6 border-light-input-border dark:border-dark-input-border"
        data-testid="post-details-tab-layout-divider"
      />

      {children}
    </div>
  );
}
